<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Kardex</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="consultar" class="btn-info btn--bigger">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button type="button" @click="exportarExcel" class="btn-success btn--bigger">
            <i class="fa fa-file-excel-o"></i><span>Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select
                  name="tipo_fecha"
                  v-model="form.tipo_fecha"
                  id="tipo_fecha"
                >
                  <option value="H">Hoy</option>
                  <option value="A">Ayer</option>
                  <option value="P">Personalizada</option>
                </select>
                <label for="tipo_fecha">Tipo de fecha</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  :disabled="form.tipo_fecha !== 'P'"
                  id="desde"
                  v-model="form.desde"
                  locale="es"
                  no-label
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD HH:mm"
                  formatted="YYYY-MM-DD HH:mm"
                  label="Seleccione fecha..."
                />
                <label>Desde</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  :disabled="form.tipo_fecha !== 'P'"
                  id="hasta"
                  v-model="form.hasta"
                  locale="es"
                  no-label
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD HH:mm"
                  formatted="YYYY-MM-DD HH:mm"
                  label="Seleccione fecha..."
                />
                <label>Hasta</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div 
              class="form-field select2"
              :class="{'select2--disabled': !administraTodasBodegas}"
            >
              <div class="select2-field">
                <v-select
                  id="bodegas"
                  placeholder="Seleccione..."
                  v-model="selectedBodegas"
                  @input="inputBodegas"
                  :options="optionsBodegas"
                  label="descripcion"
                ></v-select>
                <label for="bodegas">{{ administraTodasBodegas ? 'Bodega(s)' : 'Bodega' }}</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-8">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  placeholder="Seleccione..."
                  id="items"
                  multiple
                  v-model="selectedItems"
                  :options="items"
                  @search="searchItems"
                  @input="inputItems"
                  label="nombre"
                ></v-select>
                <label for="items">Ítem(s)</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-2">
      <div class="card__content">
        <item-kardex
          :tipo_fecha="form.tipo_fecha"
          :bodegas_id="form.bodegas_id"
          :desde="form.desde"
          :hasta="form.hasta"
          :saldosFinales="item.saldos"
          :saldosIniciales="obtenerSaldosIniciales(item)"
          v-for="(item, index) in saldosFinales"
          :key="index"
          :itemId="item.item.item_id"
          :descripcionItem="item.item.descripcion_item"
        ></item-kardex>
      </div>
    </div>
  </div>
</template>

<script>
import ItemKardex from "./ItemKardex.vue";
export default {
  components: {
    ItemKardex,
  },
  props: {
    bodegas: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    administraTodasBodegas: {
      type: Boolean,
      required: true
    },
    idBodegaUsuario: {
      required: true
    }
  },
  data: function () {
    return {
      saldosFinales: [],
      saldosIniciales: [],
      selectedBodegas: [],
      selectedItems: [],
      items: [],
      optionsBodegas: [],
      form: {
        tipo_consulta: "C",
        tipo_fecha: "H",
        desde: moment(new Date()).format("YYYY-MM-DD HH:mm"),
        hasta: moment(new Date()).format("YYYY-MM-DD HH:mm"),
        items: [],
        bodegas: [],
      },
    };
  },
  methods: {
    obtenerSaldosIniciales: function (item) {
      for (let i = 0; i < this.saldosIniciales.length; i++) {
        if (this.saldosIniciales[i].item.item_id == item.item_id) {
          return this.saldosIniciales[i].saldos;
        }
      }
      return [];
    },
    searchItems: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.items = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/items?search=" + search, true);
      xmlhttp.send();
    },
    exportarExcel: function () {
      if (this.selectedItems.length === 0) {
        swal("Debe seleccionar al menos un ítem.", "Aviso", "warning");
        return;
      }
      this.form.tipo_consulta = 'E';
      let urlApi = `${url}/kardex${this.serialize(this.form)}`;
      window.open(urlApi, '_blank');
    },
    consultar: function () {
      if (this.selectedItems.length === 0) {
        swal("Debe seleccionar al menos un ítem.", "Aviso", "warning");
        return;
      }
      this.form.tipo_consulta = 'C';
      axios
        .get(url + "/kardex", {
          params: this.form,
        })
        .then(({ data }) => {
          this.saldosIniciales = _.chain(data.saldosIniciales)
            .groupBy((x) => {
              return {
                item_id: x.item_id,
                descripcion_item: x.descripcion,
              };
            })
            .map((value, key) => ({ item: key, saldos: value }))
            .value();
          this.saldosFinales = _.chain(data.saldosFinales)
            .groupBy((x) => {
              return x.item_id + "|" + x.descripcion;
            })
            .map((value, key) => ({
              item: {
                item_id: key.split("|")[0],
                descripcion_item: key.split("|")[1],
              },
              saldos: value,
            }))
            .value();
        })
        .catch(() => {
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    inputItems: function () {
      this.form.items.splice(0, this.form.items.length);
      for (let i = 0; i < this.selectedItems.length; i++) {
        this.form.items.push(this.selectedItems[i].id);
      }
    },
    inputBodegas: function () {
      this.form.bodegas.splice(0, this.form.bodegas.length);
      for (let i = 0; i < this.selectedBodegas.length; i++) {
        this.form.bodegas.push(this.selectedBodegas[i].id);
      }
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
  },
  mounted: function() {
    if(this.administraTodasBodegas)
      this.optionsBodegas = [...this.bodegas];
    else{
      for(let i=0; i < this.bodegas.length; i++){
        if(this.idBodegaUsuario == this.bodegas[i].id){
          this.optionsBodegas.push(this.bodegas[i]);
          this.selectedBodegas.push(this.bodegas[i]);
          this.form.bodegas.push(this.bodegas[i].id);
          break;
        }
      }
    }    
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/inventario/Kardex.vue